// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"fef63e75","640":"d98480d9"}[chunkId] + ".chunk.js";
};